import React, { useState } from 'react';
import Dialog from '@components-clean/core/dialog';
import DragDropListsCore from '@components-clean/core/drag-drop-lists-core';
import { DragDropListItemProps } from '@components-clean/core/drag-drop-lists-core/drag-drop-lists-core.interface';
import {
    DataFilterDragDropDataItem,
    DataFilterDragDropItem,
    DataFilterDragDropItemProps,
} from '@pages-clean/admin/study/admin-data-views/data-views/filters/data-filter-drag-drop-item';
import { DataFilterResultType } from '@pages-clean/admin/study/admin-data-views/filters/types';
import { DataFilterSearch, mapDataFilterToDragDrop } from '@pages-clean/admin/study/admin-data-views/utils';
import { useLocalState, useTranslation } from '@hooks/index';

const DataViewFilters = ({
    dataViewFilters,
    dataViewFilterIds,
}: {
    dataViewFilters: DataFilterResultType[];
    dataViewFilterIds?: string[];
}) => {
    const { t } = useTranslation();
    const [editItem, setEditItem] = useState<DragDropListItemProps | null>(null);
    const { state } = useLocalState();
    const dataViewConfigFilters = dataViewFilterIds?.map<DataFilterDragDropDataItem>((filter) => {
        const dataViewFilter = dataViewFilters?.find((item) => item?.id === filter);
        return mapDataFilterToDragDrop(dataViewFilter, state);
    });

    return (
        <div className="k-h-full">
            {!!editItem && (
                <Dialog title="Edit Item" data-testid="edit-item-dialog" closeIcon onClose={() => setEditItem(null)}>
                    {editItem.title}
                </Dialog>
            )}

            <DragDropListsCore
                list1Header={t('admin:dataViewFilters')}
                list1Items={dataViewConfigFilters || []}
                idField="Id"
                disabled
                renderItemLeft={(item) => {
                    return (
                        <DataFilterDragDropItem
                            inactiveIconTooltip={t('admin:fieldNoLongerInUse')}
                            toDisplayColumn
                            applyCallOutClass
                            {...(item as DataFilterDragDropItemProps)}
                        />
                    );
                }}
                filterItem={DataFilterSearch}
            />
        </div>
    );
};
export { DataViewFilters };
